import React from "react";
import { Link } from "react-router-dom";
import { T, R } from "./tokens";

const BOTTOM_NAV = [
  { label: "Home",         to: R.home        },
  { label: "Library",      to: R.library     },
  { label: "Collections",  to: R.collections },
  { label: "MyCraftz",     to: R.mycraftz    },
  { label: "My Sanctuary", to: R.sanctuary   },
  { label: "Profile",      to: R.profile     },
];

const SITEMAP = [
  { label: "Blog",        to: "/blogs"       },
  { label: "About",       to: "/about"       },
  { label: "Mission",     to: "/mission"     },
  { label: "Partner",     to: "/partner"     },
  { label: "For Authors", to: "/for-authors" },
  { label: "Contact",     to: "/contact"     },
  { label: "Privacy",     to: "/privacy"     },
  { label: "Terms",       to: "/terms"       },
];

const LOTUS = "/homepage-assets/asset-5-icon-lotus-1.png";

export default function Footer({ activePath }) {
  return (
    <div data-testid="homev3-footer" className="homev3-footer-shared">
      {/* ── Quote band ─────────────────────────────────────────────── */}
      <div
        className="homev3-footer-quote flex items-center justify-between px-12 py-5"
        style={{
          background:   T.PARCHMENT_LT,
          borderTop:    "1px solid rgba(201,168,76,0.35)",
          borderBottom: "1px solid rgba(201,168,76,0.2)",
        }}
      >
        <span style={{ fontFamily: T.F_DEVNAG, fontSize: "34px", color: T.GOLD, lineHeight: 1, flexShrink: 0 }}>{"ॐ"}</span>
        <p className="m-0 text-center flex-1 px-8 homev3-footer-quote__text" style={{ fontFamily: T.F_BODY, fontSize: 16, fontStyle: "italic", color: T.DARK_BROWN, lineHeight: 1.6 }}>
          &ldquo;Transformation is not a day&rsquo;s work, but a lifetime&rsquo;s art.&rdquo;
        </p>
        <img src={LOTUS} alt="lotus" style={{ width: 36, height: 36, objectFit: "contain", flexShrink: 0 }} />
      </div>

      {/* ── Sitemap + disclaimer band ─────────────────────────────── */}
      <div
        data-testid="homev3-footer-sitemap"
        className="homev3-footer-sitemap"
        style={{
          background: T.PARCHMENT_LT,
          borderBottom: "1px solid rgba(201,168,76,0.2)",
          padding: "28px 48px 24px",
        }}
      >
        <div className="flex flex-wrap justify-center" style={{ gap: "10px 34px", marginBottom: 18 }}>
          {SITEMAP.map(({ label, to }) => (
            <Link
              key={label}
              to={to}
              data-testid={`homev3-footer-sitemap-${label.toLowerCase().replace(/\s+/g, "-")}`}
              className="no-underline"
              style={{
                fontFamily: T.F_HEADING,
                fontSize: 12,
                letterSpacing: "0.10em",
                color: T.DARK_BROWN,
                transition: "color 150ms ease",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.color = T.GOLD; }}
              onMouseLeave={(e) => { e.currentTarget.style.color = T.DARK_BROWN; }}
            >
              {label}
            </Link>
          ))}
        </div>

        <p
          data-testid="homev3-footer-disclaimer"
          className="m-0 homev3-footer-disclaimer"
          style={{
            fontFamily: T.F_BODY,
            fontSize: 12,
            fontStyle: "italic",
            lineHeight: 1.55,
            color: T.MUTED_BROWN,
            maxWidth: 920,
            margin: "0 auto",
            textAlign: "center",
          }}
        >
          <strong style={{ fontStyle: "normal", color: T.DARK_BROWN }}>Disclaimer:</strong>{" "}
          iCraftz is a behavioural-change engine. Book summaries and insights shown here are original interpretations created for educational purposes only, not reproductions of copyrighted material. All book titles and author names are property of their respective owners. This platform is not affiliated with or endorsed by any publishers or authors. If you are a rights holder and have concerns, please contact us at{" "}
          <a href="mailto:hello@icraftz.com" style={{ color: T.DARK_BROWN, textDecoration: "underline", textDecorationColor: T.GOLD }}>hello@icraftz.com</a>{" "}
          and we will promptly address your request.
        </p>
      </div>

      {/* ── Bottom nav (hidden on mobile — hamburger already covers) ─ */}
      <div
        data-testid="homev3-footer-bottom-nav"
        className="homev3-footer-bottom-nav flex items-center justify-center gap-9 px-10 py-3"
        style={{ background: "rgba(20,10,5,0.85)" }}
      >
        {BOTTOM_NAV.map(({ label, to }) => {
          const active = activePath === to;
          return (
            <Link
              key={label}
              to={to}
              data-testid={`homev3-footer-nav-${label.toLowerCase().replace(/\s+/g, "-")}`}
              className="no-underline"
              style={{
                fontFamily: T.F_HEADING,
                fontSize: 12,
                color: active ? T.GOLD : T.PARCHMENT_LT,
                letterSpacing: "0.06em",
                transition: "color 150ms ease",
              }}
              onMouseEnter={(e) => { if (!active) e.currentTarget.style.color = T.GOLD; }}
              onMouseLeave={(e) => { if (!active) e.currentTarget.style.color = T.PARCHMENT_LT; }}
            >
              {label}
            </Link>
          );
        })}
      </div>

      {/* ── Mobile responsive overrides (<900px) ──────────────────── */}
      <style>{`
        @media (max-width: 899px) {
          .homev3-footer-shared { overflow-x: hidden; }
          .homev3-footer-quote {
            padding-left: 20px !important;
            padding-right: 20px !important;
          }
          .homev3-footer-quote__text {
            font-size: 13px !important;
            padding-left: 12px !important;
            padding-right: 12px !important;
            line-height: 1.5 !important;
          }
          .homev3-footer-sitemap {
            padding: 22px 20px 20px !important;
          }
          .homev3-footer-disclaimer {
            font-size: 11px !important;
            line-height: 1.5 !important;
          }
          [data-testid="homev3-footer-bottom-nav"] {
            display: none !important;
          }
        }
      `}</style>
    </div>
  );
}
